// @ts-nocheck
// Import React and Hooks
import React, { useRef, useState, useEffect } from 'react'
// Import React Router Dom
import { useHistory } from 'react-router-dom'
// Import Redux and Hooks
import { Dispatch } from "redux"
import { useAppSelector, useAppDispatch } from '../hooks/useRedux'
// Import Actions
import { downloadCreatorOfferingAction,
  sendOfferingAction,
  showCutterImageAction,
  updateTemporalImageAction,
  updateConfirmedImageAction } from '../actions/createOfferingAction'
// Import React Hook Form
import { useForm } from 'react-hook-form'
// Import Swiper React Components
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from 'swiper'
// Import Swiper styles
import 'swiper/swiper.scss'
import 'swiper/components/pagination/pagination.scss'
import 'swiper/components/effect-fade/effect-fade.scss'
// Import Custom Hooks
import useFormCustom from '../hooks/useFormCustom'
// Import Components
import FloatImg from '../components/ui/FloatImg'
//import Background from '../components/layout/Background'
import Button from '../components/ui/Button'
import BeerMask from '../components/ui/BeerMask'
import CutterImage from '../components/ui/CutterImage'
// Import React Awesome Reveal
import { Fade } from "react-awesome-reveal"

import { toContinue2, toContinue3 } from '../actions/datalayer'

// Install Swiper modules
SwiperCore.use([Pagination, Navigation])



const CreateOffering = () => {



  // Use Selector
  const creatorOfferingSelector = useAppSelector( state => state.creatorOffering )



  // Use History
  const history = useHistory()



  // Destructuring
  const { title, text, text2, options, isLogin, hasOffering, temporalImage, confirmedImage } = creatorOfferingSelector



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use Ref
  const wrapperCarousel = useRef(null)
  const formCreateOffering = useRef(null)


  const maxSizeFile = async (image:any) => {
    try {
      if( image ) return image[0].size <= 10000000 || 'Tamaño máximo permitido 10 MB'
    } catch( error ) {
      console.log(error)
    }
  }
  const typeFile = async (image:any) => {
    try {
      if( image[0].type === 'image/jpeg' || image[0].type === 'image/jpg' || image[0].type === 'image/png' ) {
        return image
      } else {
        return 'Ingresa una imagen válida'
      }
    } catch( error ) {
      console.log(error)
    }
  }



  // Use State
  const [ swiperEl, setSwiper ] = useState<any>(null)
  const [ fileImg, setFileImg ] = useState('')
  const [ name, setName ] = useState('')
  const [ textDedication, setTextDedication ] = useState('')
  const [ offeringOptions, setOfferingOptions ] = useState([])
  const [ offeringFileInput ] = useState({
    id: 'offeringPhoto',
    label: 'toca AQUÍ para cargar la foto',
    placeholder: 'toca AQUÍ para cargar la foto',
    type: 'file',
    typeInput: 'file',
    validation: {
      required: "Este campo es requerido",
      validate: {
        maxSizeFile: maxSizeFile,
        typeFile: typeFile
      }
    }
  })
  const [ offeringNameInput ] = useState({
    id: 'offeringName',
    label: '¿QUién es esa persona que te hace florecer cuando la recuerdas?',
    placeholder: 'Nombre de tu ser amado',
    type: 'normal',
    typeInput: 'text',
    maxlength: 15,
    validation: {
      required: "Este campo es requerido",
      maxLength: {
        value: 15,
        message: "Este campo debe tener máximo 15 carácteres"
      }
    }
  })
  const [ offeringDateOfDeathInputs ] = useState({
    id: 'offeringDateOfDeath',
    title: 'Fecha de luto (Opcional)',
    type: 'group',
    inputElements: [
      {
        id: 'offeringBirthday',
        placeholder: '0000',
        type: 'normal',
        typeInput: 'number',
        maxlength: 4
      },
      {
        id: 'offeringMourningDay',
        placeholder: '0000',
        type: 'normal',
        typeInput: 'number',
        maxlength: 4
      }
    ]
  })
  const [ offeringDedicationInput ] = useState({
    id: 'offeringDedication',
    label: 'Escribe una dedicatoria a tu ser querido',
    placeholder: 'Escribe lo que te gustaria decirle',
    type: 'textarea',
    typeInput: 'textarea',
    maxlength: 500,
    validation: {
      required: "Este campo es requerido",
      maxLength: {
        value: 500,
        message: "Este campo debe tener máximo 500 carácteres"
      }
    }
  })



  // Config React Hook Form
	// const { register, watch, getValues, setValue, handleSubmit, formState: { errors, isValid } } = useForm({ mode: 'all'})
	const { register, trigger, watch, setValue, handleSubmit, formState: { errors, isValid } } = useForm({ mode: 'all'})



  // Swiper resize
  swiperEl && swiperEl.on('resize', () => updateCarousel(swiperEl, 1500) )
  swiperEl && swiperEl.on('slideChange', () => {
    window.scrollTo({
      top: 100,
      left: 0
    })
  } )



  // Use Effect
  useEffect( () => {
    dispatch(downloadCreatorOfferingAction())
    setOfferingOptions( creatorOfferingSelector.options )
    updateCarousel( swiperEl, 300 )
  }, [] )

  useEffect( () => {
    const currentTextDedication = watch().offeringDedication
    const currentName = watch().offeringName
    setTextDedication(currentTextDedication)
    setName(currentName)
    btnsBullet();
    updateCarousel( swiperEl, 300 )
  }, [ watch() ] )

  useEffect( () => {
    if( creatorOfferingSelector.text ) {
      // console.log( 'login', isLogin )
      // console.log( 'hasOffering', hasOffering )
      if( !isLogin || hasOffering ) window.location.href = '/registro-ofrendas'; //history.push('/registro-ofrendas')
    }
    setOfferingOptions( options )
    updateCarousel( swiperEl, 300 )
  }, [creatorOfferingSelector] )



  // Use Form Custom
	const { printInput } = useFormCustom()



  // Functions on submit
	const onSubmit = (data:any) => {

    console.log('first', data)
    data = {
      ...data,
      offeringPhoto: confirmedImage.url,
      token: 't0k3n0ff'
    }
    console.log('second', data)

    dispatch( sendOfferingAction( data ) )

	}

  const btnsBullet = () => {
    let bullets = document.querySelectorAll('.swiper-pagination span') as any;
    bullets[0].addEventListener("click", function(){
      let container = document.querySelector('.formOfrendas .swiper-container') as any;
      container?.classList.remove('Section2');
    })
    bullets[1].addEventListener("click", function(){
      let container = document.querySelector('.formOfrendas .swiper-container') as any;
      container?.classList.add('Section2');
    })
  }

  // Function to go next carousel
  const goNextCarousel = (e:React.MouseEvent) => {
    e.preventDefault()
    toContinue2();
    let container = document.querySelector('.formOfrendas .swiper-container') as any;
    container?.classList.add('Section2');
    swiperEl.slideNext()
  }

  // Function handle option
  function handleOption( e:any ) {
    const targetEl = e.target
    setValue('offeringDedication', targetEl.textContent, { shouldValidate: true })
  }

  // Function handle process image
  function handleProcessImage( e:any ) {
    if( !e.target.files[0] ) {
      dispatch( updateTemporalImageAction({
        url: '',
        img: ''
      }) )
      setFileImg( '' )
      return false
    }
    const imageFile = e.target.files[0]
    const imageUrl = URL.createObjectURL(imageFile)
    setFileImg( imageUrl )
    dispatch( updateTemporalImageAction({
      url: imageUrl,
      img: ''
    }) )
  }

  // Function handle
  function handleSubmitValidation( e:React.MouseEvent ) {
    e.preventDefault()

    const watchForm = watch()

    trigger()

    if( watchForm.offeringName === '' || watchForm.offeringPhoto.length <= 0 ) swiperEl.slidePrev()

    if(isValid){
      toContinue3();
      handleSubmit(onSubmit)()
    }
    //if( isValid ) toContinue3()()
    //if( isValid ) handleSubmit(onSubmit)()

  }

  // Function handle open
  function handleOpenCutterImage() {
    setTimeout( () => {
      dispatch( showCutterImageAction(true) )
      let menu = document.querySelector('main[role="main"]');
      menu.classList.add('zIndex');
    }, 2000 )
  }

  // Function update Carousel
  function updateCarousel( carouselEl:any, time:number ) {
    carouselEl && setTimeout( () => carouselEl.update(), time )
  }



  return (
    <div className="container container--createOffering">
      <CutterImage dataCutterImage={{
        title: 'FOTOGRAFÍa',
        subtitle: 'Coloca la foto DE TU SER <br /> QUERIDO en el area visible ',
        text: 'TAMAÑO recomendado: 410 X 540 PIXELES' }}
        initializerElement={ offeringFileInput.id } />
      <form
        className="form formOfrendas"
        ref={ formCreateOffering }
        encType='multipart/form-data'
        onSubmit={ handleSubmit( onSubmit ) } >
        <Swiper
          breakpoints={{
            0: {
              direction: 'horizontal',
              autoHeight: true
            },
            991: {
              direction: 'vertical',
              autoHeight: false
            }
          }}
          slidesPerView={ 1 }
          allowTouchMove={ false }
          pagination={{
            'clickable': true
          }}
          onSwiper={ setSwiper }
          className='carousel carousel--vertical' >
            <SwiperSlide className="carousel__slide">
              <div className="carousel__side">
                { title && (
                  <h2 className="form__title hiddenUpMobile taC mb15">
                    { title }
                  </h2>
                ) }
                { text && (
                  <p className="form__text hiddenUpMobile taC mb60">
                    { text }
                  </p>
                ) }
                {/* FILE INPUT */}
                <article className="fileInput">
                  <div className="fileInput__photo">
                    <span className="fileInput__photo__halo" />
                    <picture className="fileInput__photo__picture">
                      {/* <img src={ fileImg } alt="" className="fileInput__photo__img" /> */}
                      <img src={ confirmedImage.url } alt="" className="fileInput__photo__img" />
                      <div className="fileInput__requirements">
                        {/* <div className={`fileInput__requirements__wrapper ${ fileImg.length > 0 ? 'hide' : '' } `}> */}
                        <div className="fileInput__requirements__wrapper">
                          <span className="fileInput__requirements__icon" />
                          <p className="fileInput__requirements__title">
                           toca AQUÍ para cargar la foto
                          </p>
                          <p className="fileInput__requirements__text">
                            Máx 10 MB
                          </p>
                        </div>
                        <input
                          type={ offeringFileInput.type }
                          id={ offeringFileInput.id }
                          accept=".png, .jpg, .jpeg"
                          className="form__input"
                          { ...register( offeringFileInput.id, offeringFileInput.validation ) }
                          placeholder={ offeringFileInput.placeholder }
                          onClick={ handleOpenCutterImage }
                          onChange={ handleProcessImage } />
                        { errors[offeringFileInput.id] &&
                          <Fade
                            direction='up'
                            duration={ 500 } >
                            <p className="form__error">{ errors[offeringFileInput.id].message }</p>
                          </Fade >
                        }
                      </div>
                    </picture>
                    <FloatImg
                      additionalClass="birdOffering1"
                      alt="Pajaro"
                      src={`${window.assetsURl}/imgs/shapes/colibriNew+(1).png`} />
                    <FloatImg
                      additionalClass="birdOffering2"
                      alt="Pajaro"
                      src={`${window.assetsURl}/imgs/shapes/colibriNew2+(1).png`} />
                  </div>
                </article>
                {/* END FILE INPUT */}
              </div>
              <div className="carousel__side sideConstructOfrendas">
                { title && (
                  <h2 className="form__title hiddenMobile taL taMC mb30">
                    { title }
                  </h2>
                ) }
                { offeringNameInput && printInput( offeringNameInput, register, errors, 'w100 pr40 prM0' ) }
                { offeringDateOfDeathInputs && printInput( offeringDateOfDeathInputs, register, errors, 'form__group--death w100 pr40 prM0 mb10' ) }
                <Button
                  additionalClass='mr40 mrM0'
                  functionClick={ goNextCarousel }
                  url="#"
                  text="CONTINUAR" />
              </div>
            </SwiperSlide>
            <SwiperSlide className="carousel__slide">
              <div className="carousel__side sideRes">
                {/* BEER MASK */}
                <BeerMask
                  // fileImg={ fileImg }
                  fileImg={ confirmedImage.url }
                  name={ name }
                  textDedication={ textDedication }
                  additionalClass='mb0 mbM40 resp0nsiveClas'
                  canRotate />
                {/* END BEER MASK */}
                <div className="dF w100 hiddenUpMobile form__box taC mt30 mb20 mbM0">
                  <Button
                    additionalClass='btn--animated'
                    text='Crea una ofrenda'
                    functionClick={ (e) => handleSubmitValidation(e) } />
                </div>
              </div>
              <div className="carousel__side invert">
                <h2 className="form__title taL taMC mb35 mb25">
                  { title }
                </h2>
                {/* <p className="form__text taL taMC mb35">
                  { text2 }
                </p> */}
                { offeringDedicationInput && printInput( offeringDedicationInput, register, errors, 'w100 pr40 prM0' ) }
               
                <div
                  className="wrapperCarousel mb10 mbM20"
                  ref={ wrapperCarousel }>
                  <h3 className="carousel__title">Puedes escoger una DE NUESTRAS DEDICATORIAS:</h3>
                  { offeringOptions.length > 0 && (
                    <Swiper
                      direction={'horizontal'}
                      slidesPerView={ 1 }
                      spaceBetween={ 30 }
                      allowTouchMove={ true }
                      pagination={{
                        el: '.carousel__pagination',
                        clickable: true
                      }}
                      navigation={{
                        prevEl: '.carousel__prev',
                        nextEl: '.carousel__next'
                      }}
                      className='carousel carousel--options' >
                        {
                          offeringOptions.length > 0 && offeringOptions.map( (optionItem:string, index:number) => {
                            return <SwiperSlide
                              key={ index }
                              className="carousel__slide" >
                              <div
                                className="carousel__option"
                                onClick={ e => handleOption(e) } >
                                { optionItem }
                              </div>
                            </SwiperSlide>
                          } )
                        }
                      <div className="carousel__pagination" />
                    </Swiper>
                  ) }
                  <div className="carousel__prev" />
                  <div className="carousel__next" />
                </div>
                <div className="dF w100 hiddenMobile form__box taC mt30 mb20 mbM0 pr40 prM0">
                  {/* <Button
                    type='submit'
                    text='Crea una ofrenda' /> */}
                  <Button
                    additionalClass='btn--animated'
                    text='Crea una ofrenda'
                    functionClick={ (e) => handleSubmitValidation(e) } />
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
      </form>
    </div>
  )
}



export default CreateOffering
